import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { useSelectionDispatch } from 'modules/shift_management/hooks/useSelection'

const ClearSelectionButton = () => {
  const dispatchSelection = useSelectionDispatch()

  const onClick = () => {
    dispatchSelection({
      type: 'CLEAR_SELECTION',
    })
  }

  return (
    <Button type="secondary" onClick={onClick} disabled={false} iconName="cross-circle">
      {i18n.t('shift_management.clear_selection')}
    </Button>
  )
}

export default ClearSelectionButton
